module.exports = __webpack_public_path__ + "static/logo-small-5013f0fda0c00efe109feb24a8489de7.jpg";